module.exports = __webpack_public_path__ + "img/ROUND SHADES BW.e23d01a.svg";